import { designerObjectTypeOrNull } from '@wirechunk/lib/designer/object-type.ts';
import {
  freeSitePreviewParamName,
  visualPreviewObjectTypeParamName,
} from '@wirechunk/lib/mixer/visual-preview.ts';

// The URL search params on page load.
export const initialSearchParams = new URLSearchParams(window.location.search);

// The value of the preview object type parameter on page load.
export const visualPreviewObjectType = designerObjectTypeOrNull(
  initialSearchParams.get(visualPreviewObjectTypeParamName),
);

// Whether the site is being previewed for free.
export const freeSitePreview = initialSearchParams.has(freeSitePreviewParamName);
